import "../assets/index-17673ea1.css";
import { n as r } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const l = {
  name: "NcCounterBubble",
  props: {
    type: {
      type: String,
      default: "",
      validator(t) {
        return ["highlighted", "outlined", ""].indexOf(t) !== -1;
      }
    },
    /**
     * Specifies whether the component is used within a component that is
     * active and therefore has a primary background. Inverts the color of
     * this component when that is the case.
     */
    active: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    counterClassObject() {
      return {
        "counter-bubble__counter--highlighted": this.type === "highlighted",
        "counter-bubble__counter--outlined": this.type === "outlined",
        active: this.active
      };
    }
  }
};
var o = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "counter-bubble__counter", class: e.counterClassObject }, [e._t("default")], 2);
}, u = [], c = /* @__PURE__ */ r(
  l,
  o,
  u,
  !1,
  null,
  "b318b0e4",
  null,
  null
);
const a = c.exports;
export {
  a as default
};
